"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var KeyCodes_1 = require("../../utils/KeyCodes");

var RuleSeparator_1 = __importDefault(require("./RuleSeparator"));

var RuleComponent_1 = __importDefault(require("./RuleComponent"));

require("./RulesCSS.scss");

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

var ba_react_html5_dnd_1 = __importDefault(require("corsair_ship/ba-react-html5-dnd"));

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

var ObserverNoDnDContextRulesComponent =
/** @class */
function (_super) {
  __extends(ObserverNoDnDContextRulesComponent, _super);

  function ObserverNoDnDContextRulesComponent(props) {
    var _this = _super.call(this, props) || this;

    _this._rulesRef = [];
    var conditionalFormatModel = _this.props.conditionalFormatModel;
    var rules = conditionalFormatModel.getRules();

    for (var idx = 0; idx < rules.length; idx++) {
      _this._rulesRef.push(react_1.default.createRef());
    }

    return _this;
  }

  ObserverNoDnDContextRulesComponent.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        conditionalFormatModel = _a.conditionalFormatModel,
        uiContext = _a.uiContext,
        disabled = _a.disabled;
    var rules = conditionalFormatModel.getRules();
    return react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      id: 'vis-cf-rules-container',
      direction: 'column'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, null, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      className: 'vis-cf-rule-title',
      label: StringResources_1.default.get('conditionalFormattingRules')
    })), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: ca_ui_toolkit_1.classnames(disabled ? 'vis-cf-rule-container-disabled' : 'vis-cf-rule-container')
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'column',
      id: 'vis-cf-rule-list',
      className: ca_ui_toolkit_1.classnames('vis-cf-rulesList-dropzone')
    }, rules.map(function (ruleModel, idx) {
      return react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
        key: idx
      }, react_1.default.createElement(RuleSeparator_1.default, {
        dropIndex: idx
      }), react_1.default.createElement(RuleComponent_1.default, {
        ref: _this._rulesRef[idx],
        key: idx,
        ruleModel: ruleModel,
        ruleIndex: idx,
        removeRule: _this._removeRule.bind(_this),
        onRowMove: _this._reOrderRules.bind(_this),
        uiContext: uiContext,
        scale: conditionalFormatModel.getScale(),
        paletteId: conditionalFormatModel.getPaletteId(),
        colorPickerModel: conditionalFormatModel.getColorPickerModel(),
        backgroundOpacity: conditionalFormatModel.getBackgroundOpacity()
      }));
    }), react_1.default.createElement(RuleSeparator_1.default, {
      dropIndex: rules.length
    }))), react_1.default.createElement(ca_ui_toolkit_1.VSpacer, {
      size: 2
    }), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: ca_ui_toolkit_1.classnames('vis-cf-add-rule-container')
    }, react_1.default.createElement(ca_ui_toolkit_1.Button, {
      className: ca_ui_toolkit_1.classnames('vis-cf-add-rule-button'),
      iconRight: uiContext.getIcons().getIcon('add16'),
      size: 'small',
      button: false,
      tabIndex: 0,
      focusable: true,
      disabled: conditionalFormatModel.shouldAddRuleBeDisabled,
      label: StringResources_1.default.get('conditionalFormattingAddRule'),
      onClick: function onClick() {
        return conditionalFormatModel.addRule();
      },
      onKeyDown: function onKeyDown(e) {
        if (e.keyCode === KeyCodes_1.KeyCodes.ENTER || e.keyCode === KeyCodes_1.KeyCodes.SPACE) {
          conditionalFormatModel.addRule(); // Prevent browser's default action: space does a PageDown

          e.preventDefault();
        }
      }
    })));
  };

  ObserverNoDnDContextRulesComponent.prototype.expandExpandableTile = function () {
    this._rulesRef.forEach(function (ruleRef) {
      if (ruleRef.current) {
        ruleRef.current.expandExpandableTile();
      }
    });
  };

  ObserverNoDnDContextRulesComponent.prototype.onPropertiesPanelMounted = function () {
    this._rulesRef.forEach(function (ruleRef) {
      if (ruleRef.current) {
        ruleRef.current.updateExpansionStateWhenPropertiesPanelMounted();
      }
    });
  };

  ObserverNoDnDContextRulesComponent.prototype.collapseExpandableTile = function () {
    this._rulesRef.forEach(function (ruleRef) {
      if (ruleRef.current) {
        ruleRef.current.collapseExpandableTile();
      }
    });
  };

  ObserverNoDnDContextRulesComponent.prototype._reOrderRules = function (from, to) {
    var conditionalFormatModel = this.props.conditionalFormatModel;
    conditionalFormatModel.moveRule(from, to);
  };

  ObserverNoDnDContextRulesComponent.prototype._removeRule = function (index) {
    var conditionalFormatModel = this.props.conditionalFormatModel;
    conditionalFormatModel.deleteRule(index);
  };

  return ObserverNoDnDContextRulesComponent;
}(react_1.Component);

var NoDnDContextRulesComponent = mobx_react_1.observer(ObserverNoDnDContextRulesComponent);
exports.NoDnDContextRulesComponent = NoDnDContextRulesComponent;
var RulesComponent = ba_react_html5_dnd_1.default(NoDnDContextRulesComponent);
exports.default = RulesComponent;
